document.documentElement.classList.remove('no-js');

// Menu mobile
document.addEventListener('click', (e) => {
  const open = e.target.closest('[data-menu-open]');
  const close = e.target.closest('[data-menu-close]');
  const nav = document.querySelector('.mobile-nav');
  if (!nav) return;
  if (open) { nav.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  if (close) { nav.classList.remove('is-open'); document.body.style.overflow = ''; }
});

// Apparition au défilement
(() => {
  const els = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) { els.forEach(el => el.classList.add('is-visible')); return; }
  const io = new IntersectionObserver((entries) => {
    entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); } });
  }, { threshold: 0.12 });
  els.forEach(el => io.observe(el));
})();

// Fiche produit : galerie, quantité, variantes
document.querySelectorAll('[data-product]').forEach((root) => {
  const main = root.querySelector('[data-main-image]');
  root.querySelectorAll('[data-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      main.src = btn.dataset.src;
      root.querySelectorAll('[data-thumb]').forEach(b => b.setAttribute('aria-current', 'false'));
      btn.setAttribute('aria-current', 'true');
    });
  });

  const qty = root.querySelector('[data-qty]');
  root.querySelectorAll('[data-qty-step]').forEach((b) => b.addEventListener('click', () => {
    const v = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
    qty.value = v;
  }));

  const json = root.querySelector('[data-variants]');
  if (!json) return;
  const variants = JSON.parse(json.textContent);
  const idInput = root.querySelector('[name="id"]');
  const priceEl = root.querySelector('[data-price]');
  const skuEl = root.querySelector('[data-sku]');
  const submit = root.querySelector('[data-submit]');
  const quoteLink = root.querySelector('[data-quote-link]');
  const fmt = (cents) => (cents / 100).toLocaleString(document.documentElement.lang || 'fr', { style: 'currency', currency: window.VM_CURRENCY || 'MAD' });

  root.querySelectorAll('[data-option]').forEach((input) => input.addEventListener('change', () => {
    const chosen = [...root.querySelectorAll('[data-option-group]')].map(g => (g.querySelector('input:checked') || g.querySelector('select'))?.value);
    const v = variants.find(v => v.options.every((o, i) => o === chosen[i]));
    if (!v) { submit && (submit.disabled = true); return; }
    idInput.value = v.id;
    if (skuEl) skuEl.textContent = v.sku ? 'Réf. ' + v.sku : '';
    if (priceEl) priceEl.textContent = v.price > 0 ? fmt(v.price) : priceEl.dataset.quoteLabel;
    if (submit) {
      submit.disabled = !v.available || v.price === 0;
      submit.textContent = v.price === 0 ? submit.dataset.quoteLabel : (v.available ? submit.dataset.addLabel : submit.dataset.soldLabel);
    }
    if (quoteLink) {
      const u = new URL(quoteLink.href, location.origin);
      u.searchParams.set('ref', v.sku || '');
      quoteLink.href = u.pathname + u.search;
    }
    const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
  }));
});

// Page devis : pré-remplissage depuis ?produit=&ref=
(() => {
  const field = document.querySelector('[data-quote-products]');
  if (!field) return;
  const p = new URLSearchParams(location.search);
  const name = p.get('produit'); const ref = p.get('ref');
  if (name && !field.value) field.value = name + (ref ? ' (réf. ' + ref + ')' : '') + ' — quantité : ';
})();

// Tri collection
document.querySelectorAll('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
  const url = new URL(location.href); url.searchParams.set('sort_by', sel.value); location.href = url;
}));
